"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_final_form_1 = require("react-final-form");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var Step1 = function (_a) {
    var setNextStep = _a.setNextStep, durationHoursOptions = _a.durationHoursOptions, durationMinutesOptions = _a.durationMinutesOptions;
    var t = (0, next_intl_1.useTranslations)('translation');
    var formState = (0, react_final_form_1.useFormState)();
    var isSubmitAvailable = (0, react_1.useMemo)(function () {
        var _a, _b, _c, _d;
        if (!((_a = formState.values) === null || _a === void 0 ? void 0 : _a['hours']) || !((_b = formState.values) === null || _b === void 0 ? void 0 : _b['minutes']))
            return false;
        return !(Number((_c = formState.values) === null || _c === void 0 ? void 0 : _c['hours'].value) === 0 &&
            Number((_d = formState.values) === null || _d === void 0 ? void 0 : _d['minutes'].value) === 0);
    }, [formState]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t('sessionTimeLimit')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.description }, t('sessionTimeLimitDescription')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.durationPeriod }, t('durationPeriod')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.durationPeriodContainer },
                react_1.default.createElement(react_final_form_1.Field, { name: "hours", render: function (_a) {
                        var input = _a.input;
                        return (react_1.default.createElement("div", null,
                            react_1.default.createElement("div", { className: styles_module_scss_1.default.label }, t('hours')),
                            react_1.default.createElement(ui_components_1.InputSelectSecondary, __assign({}, input, { inputName: "hours", options: durationHoursOptions, isSearchable: false }))));
                    } }),
                react_1.default.createElement(react_final_form_1.Field, { name: "minutes", render: function (_a) {
                        var input = _a.input;
                        return (react_1.default.createElement("div", null,
                            react_1.default.createElement("div", { className: styles_module_scss_1.default.label }, t('minutes')),
                            react_1.default.createElement(ui_components_1.InputSelectSecondary, __assign({}, input, { inputName: "minutes", options: durationMinutesOptions, isSearchable: false }))));
                    } }))),
        react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", onClick: setNextStep, maxWidth: "335px", width: "100%", disabled: !isSubmitAvailable }, t('submit'))));
};
exports.default = Step1;
